import $ from 'jquery';

function states() {
  const map = document.getElementById('map');
  const currentStateCode = map.dataset.currentStateCode;
  const regionalStates   = JSON.parse(map.dataset.regionalStates);
  const readonly         = map.dataset.readonly === 'true';

  // initialize the hidden field for states selected
  $('#states_list').val(JSON.stringify(regionalStates));

  // current state is red, selected states green
  const specificStyles = {};
  specificStyles[currentStateCode] = { fill: 'red' };

  regionalStates.forEach(state => {
    specificStyles[state] = { fill: 'green' };
  });

  $('#map').usmap({
    stateStyles: {
      fill: 'lightGray',
    },
    stateSpecificStyles: specificStyles,
    mouseover: function(event) {
      if (readonly) event.preventDefault();
    },
    click: function(event, data) {
      if (readonly) return;

      // don't allow current state to be selected
      if (data.name != currentStateCode) {
        // add green as a specific style or delete to toggle state highlight
        if (this.stateSpecificStyles[data.name]) {
          delete this.stateSpecificStyles[data.name];
        } else {
          this.stateSpecificStyles[data.name] = { fill: 'green' };
        }
      }

      // this could be more intelligent, but I'm just recalculating along the way
      const regionalStates = [];

      for (let key in this.stateSpecificStyles) {
        if (this.stateSpecificStyles[key]['fill'] != 'red') {
          regionalStates.push(key);
        }
      }

      $('#states_list').val(JSON.stringify(regionalStates))
    },
  });
}

$(document).ready(() => {
  // assumes the checkboxes have the class "toggle"
  $('input[type="checkbox"].toogle').bootstrapToggle();

  const map = document.getElementById('map');

  if (map && map.dataset.regionalStates) {
    states();
  }

  // States index page: navigate to state editor on map click
  if (map && !map.dataset.regionalStates) {
    $('#map').usmap({
      stateStyles: { fill: 'lightGray' },
      click: function(event, data) {
        window.location = '/states/' + data.name + '/edit_regional_states';
      },
    });
  }

  $('input[class=eula_radio_activation]').change(function() {
    const rbtn = $(this);
    const state_id = rbtn.data('state-id');
    const state_eula_id = rbtn.attr('value');
    const arr = { state_id: state_id, state_eula_id: state_eula_id };

    $.ajax({
      url: "/states/activate_eula",
      type: "POST",
      timeout: 20000,
      data: JSON.stringify(arr),
      contentType: 'application/json; charset=utf-8',
      dataType: 'text',
    }).fail(function() {
      window.location.href = window.location.href;
    });
  });

  $(document).on('click', '.js-info-toggle', function() {
    const target = $(this).data('help-target');
    $(target).toggle();
  });
});
